import type { INotification } from '../../types/interfaces/IUI';

export const notifyApiSuccess = (
  addNotification: (notification: Omit<INotification, 'id'>) => void,
  title: string,
  message: string
): void => {
  addNotification({ type: 'success', title, message });
};
